const freecourses = [
  {
    id: 1,
    coursetitle: "Automata Theory & Theory of Computation",
    playlist:
      "https://www.youtube.com/playlist?list=PLCA5omKpatF8-YLcQ6ZtKbYrVx2WesPnY",
    heroimage:
      "https://cdn.pixabay.com/photo/2020/10/21/18/07/laptop-5673901_1280.jpg",
    faculty: "Nirmalya Sengupta"
  },
  {
    id: 2,
    coursetitle: "Data Structures & Algorithms",
    playlist:
      "https://www.youtube.com/playlist?list=PLCA5omKpatF_rgPu63ZCrUIYCwsk30w9A",
    heroimage:
      "https://cdn.pixabay.com/photo/2017/09/08/08/57/binary-2728117_1280.jpg",
    faculty: "Soumyadeep Paul"
  },
  {
    id: 3,
    coursetitle: "Operating System",
    playlist:
      "https://www.youtube.com/playlist?list=PLCA5omKpatF9mdVqMtHfLWHNwnCK1rHVX",
    heroimage:
      "https://cdn.pixabay.com/photo/2017/07/16/11/13/binary-code-2508931_1280.jpg",
    faculty: "Ushashi Chowdhury"
  },
  {
    id: 4,
    coursetitle: "Digital Electronics",
    playlist:
      "https://www.youtube.com/playlist?list=PLCA5omKpatF-nAaUlUbwfb9wnJiQKs2KE",
    heroimage:
      "https://cdn.pixabay.com/photo/2021/12/02/06/03/digitization-6839721_960_720.jpg",
    faculty: "Nirmalya Sengupta"
  },
  {
    id: 5,
    coursetitle: "Wordpress Development Using Elementor",
    playlist:
      "https://www.youtube.com/playlist?list=PLCA5omKpatF8SEMeT1GXFZ3LBCEib8k5M",
    heroimage:
      "https://cdn.pixabay.com/photo/2014/12/28/13/20/wordpress-581849_1280.jpg",
    faculty: "Tushar Kanti Bera"
  },
  {
    id: 6,
    coursetitle: "C Programming Language",
    playlist:
      "https://www.youtube.com/playlist?list=PLCA5omKpatF8jA4dVEeqsl4sawrrLxi3n",
    heroimage:
      "https://cdn.pixabay.com/photo/2019/08/28/19/09/binary-4437419_960_720.jpg",
    faculty: "Soumyadeep Paul"
  },
  {
    id: 7,
    coursetitle: "Python Programming",
    playlist:
      "https://www.youtube.com/playlist?list=PLCA5omKpatF89tx5klBP3MQYbstpkTK5D",
    heroimage:
      "https://cdn.pixabay.com/photo/2016/11/19/22/52/coding-1841550_1280.jpg",
    faculty: "Arnab Majumdar"
  },
  {
    id: 8,
    coursetitle: "Free AI, chatGPT And Prompt Engineering",
    playlist:
      "https://www.youtube.com/playlist?list=PLCA5omKpatF8NR5iqKlbGd6X6mMdBLs-R",
    heroimage:
      "https://cdn.pixabay.com/photo/2023/02/05/01/10/robot-7768527_1280.jpg",
    faculty: "Suvashree Karmakar"
  },
  
];
export default freecourses;
